import { take, fork, cancel, call, put, cancelled } from 'redux-saga/effects';

import { handleApiErrors } from '../../../lib/api-errors';

import {
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_REQUESTING,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
} from './constants';

import { setClient, unsetClient } from '../../../containers/client/actions';
import { Logout } from '../../../components/modal/login/actions';

import { CLIENT_UNSET } from '../../../containers/client/constants';

import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

const loginUrl = `${process.env.REACT_APP_API_URL}`;

function loginApi(username, password) {
  const hashDigest = sha256(password)
  const _base64Hash = Base64.stringify(hashDigest)
  console.log(_base64Hash)

  return fetch(loginUrl + '/loginAdv', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify({
      user: username,
      pass: _base64Hash,
    }),
  })
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => {
      if (json.http !== 200) {
        throw Error(json.data.message);
      }
      return json.data;
    })
    .catch((error) => {
      throw error;
    });
}

function logoutApi(username, session) {
  return fetch(loginUrl + '/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify({
      user: username,
      session: session,
    }),
  })
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => {
      if (json.http !== 200) {
        throw Error(json.msg);
      }
      return json.msg;
    })
    .catch((error) => {
      throw error;
    });
}

function* logout() {
  yield put(unsetClient());

  localStorage.removeItem('token');
  sessionStorage.removeItem('authen');
}

function* loginFlow(username, password) {
  let token;
  try {
    token = yield call(loginApi, username.trim(), password.trim());

    console.log(token);

    // yield put(setClient(token));

    // const firstLogin = token['config'] ? token['config']['data']['firstLogin'] : 0;
    // if(firstLogin === 0){
    //   localStorage.setItem('token', JSON.stringify(token));
    // }

    yield put({ type: LOGIN_SUCCESS, token: token });
  } catch (error) {
    // error? send it to redux
    yield put({ type: LOGIN_ERROR, error });
  } finally {
    if (yield cancelled()) {
    }
  }

  return token;
}

function* logoutFlow(username, session) {
  let token;
  try {
    token = yield call(logoutApi, username, session);
    console.log(token);
    yield put({ type: LOGOUT_SUCCESS });
  } catch (error) {
    // error? send it to redux
    yield put({ type: LOGOUT_ERROR, error });
  } finally {
    if (yield cancelled()) {
      //
    }
  }

  return token;
}

function* loginWatcher() {
  while (true) {
    const { username, password } = yield take(LOGIN_REQUESTING);

    const task = yield fork(loginFlow, username, password);

    const action = yield take([
      CLIENT_UNSET,
      LOGIN_ERROR,
      LOGOUT_REQUESTING,
      'INVALID_SESSION',
      'LOG_OUT',
    ]);

    if (
      action.type === CLIENT_UNSET ||
      action.type === 'INVALID_SESSION' ||
      action.type === 'LOG_OUT'
    )
      yield cancel(task);
    if (action.type === LOGOUT_REQUESTING)
      yield fork(logoutFlow, action.username, action.session);
    yield call(logout);
  }
}

export default loginWatcher;
